import { render, staticRenderFns } from "./GroupBulkEditModal.vue?vue&type=template&id=2dddec62&scoped=true&"
import script from "./GroupBulkEditModal.vue?vue&type=script&lang=js&"
export * from "./GroupBulkEditModal.vue?vue&type=script&lang=js&"
import style1 from "./GroupBulkEditModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dddec62",
  null
  
)

export default component.exports